const records = 'material-specifications';
// const records = 'inventory-items';
const adjustments = 'inventory-adjustments';
const bins = 'inventory-bins';
const countHistory = 'inventory-count-history';
const purchases = 'inventory-purchases';
const snapshots = 'inventory-snapshots';
const periodClosing = 'period-closing';
const consumptionRecords = 'consumption-records';

export default {
  records,
  adjustments,
  bins,
  countHistory,
  purchases,
  snapshots,
  periodClosing,
  consumptionRecords,
};
